<template>
	<div class="left-menu">
		<img class="logo-banner" src="~@/assets/logo2.png" @click="onClickHomeLogo()" />
		<div class="menu-list">
			<img class="menu-item-bg" src="~@/assets/left-menu-bg.png" :style="itemBgStyle" />
			<div class="inline-column menu-item" v-for="(item, idx) in menuList" :key="idx"
				:style="{top: 'calc('+((72+9) * idx)+'px * var(--scale-rate))' }" @click="onClickMenuItem(idx)">
				<div class="caption">{{item.caption}}</div>
				<div class="caption-en">{{item.captionEn}}</div>
			</div>
		</div>
		<div class="channel-list">
			<el-tooltip placement="top" v-for="(channel, idx) in channelList" :key="idx" effect="light" 
				popper-class="popperclass">
				<div slot="content">
					<img :src="channel.qrCodeUrl" width="112" />
				</div>
				<a class="channel-item" :class="`item${channel.channelType}`"></a>
			</el-tooltip>
		</div>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import ChannelMixin from '../mixins/channelMixin.js';
	import MenuMixin from '../mixins/menuMixin.js';
	export default {
		name: 'LeftMenu',
		mixins: [ChannelMixin, MenuMixin],
		data() {
			return {
				
			}
		},
		computed: {
			...mapGetters(["scaleRate"]),
			itemBgStyle() {
				if (this.curIdx < 0) return {
					display: 'none'
				};
				return {
					top: 'calc(' + ((72 + 9) * this.curIdx) + 'px * var(--scale-rate))'
				}
			},
			showDivider() {
				if(this.$route && ['searchList'].includes(this.$route.name)) {
					return true;
				}else {
					return false;
				}
			}
		},
		async mounted() {
			await this.loadData();
		},
		methods: {
			
		}
	}
</script>

<style scoped lang="less">
	.left-menu {
		padding: calc(31px * var(--scale-rate)) 0 0 calc(92px * var(--scale-rate));
		width: calc(450px * var(--scale-rate));
		position: relative;
		
		.divider-line {
			position: absolute;
			border-right: 1px dashed rgb(49, 75, 137);
			width: 1px;
			right: 0;
			top: calc(65px * var(--scale-rate));
			bottom: calc(50px * var(--scale-rate));
			.icon-block {
				position: absolute;
				width: calc(11px * var(--scale-rate));
				height: calc(11px * var(--scale-rate));
				left: calc(-5px * var(--scale-rate));
				transform: rotate(45deg);
				background-color: rgb(49, 75, 137);
				display: block;
			}
		}

		.logo-banner {
			width: calc(257px * var(--scale-rate));
			height: calc(68px * var(--scale-rate));
			cursor: pointer;
		}

		.menu-list {
			margin-top: calc(84px * var(--scale-rate));
			padding-left: calc(75px * var(--scale-rate));
			position: relative;

			.menu-item-bg {
				width: calc(279px * var(--scale-rate));
				height: calc(72px * var(--scale-rate));
				object-fit: fill;
				position: absolute;
				z-index: 0;
				transition: 0.2s;
			}

			.menu-item {
				cursor: pointer;
				position: absolute;
				width: calc(192px * var(--scale-rate));
				height: calc(72px * var(--scale-rate));
				z-index: 10;
				line-height: var(--scale-rate);

				.caption {
					display: inline-block;
					white-space: nowrap;
					font-weight: 500;
					font-size: 24px;
					transform: scale(var(--scale-rate));
					-ms-transform: scale(var(--scale-rate));
					-webkit-transform: scale(var(--scale-rate));
					letter-spacing: calc(2px * var(--scale-rate));
					margin-top: calc(10px * var(--scale-rate));
				}

				.caption-en {
					display: inline-block;
					white-space: nowrap;
					font-size: 11.76px;
					transform: scale(var(--scale-rate));
					-ms-transform: scale(var(--scale-rate));
					-webkit-transform: scale(var(--scale-rate));
					margin-top: calc(7px * var(--scale-rate));
					letter-spacing: calc(-0.8px * var(--scale-rate));
				}
			}
		}

		.channel-list {
			position: absolute;
			z-index: 999;
			background-color: #FFFFFF;
			width: calc(220px * var(--scale-rate));
			//height: calc(70px * var(--scale-rate));
			bottom: calc(30px * var(--scale-rate));
			right: calc((100% - 220px * var(--scale-rate)) / 2);
			display: flex;
			box-sizing: border-box;
			flex-flow: row wrap;

			.item1 {
				background: url('~@/assets/png/icon-channel1.png') no-repeat center bottom;
			}

			.item2 {
				background: url('~@/assets/png/icon-channel2.png') no-repeat center bottom;
			}

			.item3 {
				background: url('~@/assets/png/icon-channel3.png') no-repeat center bottom;
				width: calc(26px * var(--scale-rate)) !important;
				height: calc(26px * var(--scale-rate)) !important;
			}

			.item4 {
				background: url('~@/assets/png/icon-channel4.png') no-repeat center bottom;
			}

			.channel-item {
				display: inline-block;
				transition: 0.4s;
				margin: calc(15px * var(--scale-rate));
				width: calc(24px * var(--scale-rate));
				height: calc(24px * var(--scale-rate));
				background-size: 100% 200%;

				&:hover {
					background-position: center top;
				}
			}
		}
	}
</style>
<style lang="less">
	.popperclass {
		border: 1px solid #dbdbdb !important;
		padding: 5px !important;
		.popper__arrow {
			border-top-color: #dbdbdb !important;
		}
	}
</style>